import React, { Component } from 'react'
import { PageDesiger } from './PageDesiger'
import { RouteComponentProps } from 'react-router'

export default class PageHandler extends Component<RouteComponentProps> {
	render() {
		let params = this.props.match.params as any
		return <PageDesiger {...params} />
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/PageHandler.tsx